import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id='about'>
        <div className='about-container'>
            <div className='about-heading'data-aos="flip-left">
                <strong>About Me</strong>
                <h3>The best way to predict future is to invent it!</h3>
                <a href='tel:0374481936' className='btn-link'>
                    037-448-1936 
                    <i class="fa-solid fa-phone-flip"></i>
                </a><br></br><br></br>
                <a href='https://www.linkedin.com/in/chaitali-padalkar-61b589230/' className='btn-link linkedin'>
                    Chaitali Padalkar - Linkedin
                    <i class="fa-brands fa-linkedin"></i>
                </a>
            </div>

            <div className='about-details'data-aos="flip-right">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
            </div>

        </div>
    </section>
  )
}

export default About
